module.exports = __webpack_public_path__ + "img/8.bc3fa137.webp";